/**
 * 在这里定义项目的全局函数
 * 通常是一些格式化方法等
 */
import html2canvas from 'html2canvas'
import JSPDF from 'jspdf'



export default {

  /**
   * 例如：
   * Vue.prototype.funName = function(){
   *    //do someting
   * }
   */

  // 将单位为分的价格，格式化为保留两位小数的元。
  ccFormatPrice: function (price) {
    let p = price / 100
    p = p.toFixed(2)
    return p
  },

  // 将单位为元的价格格式化为两个小数点
  ccFormatPriceFromYuan: function (price) {
    let p = price * 100 / 100
    p = p.toFixed(2)
    return p
  },

  // 合并对象的属性
  // isOverWrite : 是否覆盖
  // s: 源对象
  // r:目标对象
  // 返回：r对象
  ccMergeProps: function (r, s, isOverWrite) { // TODO:
    if (!s || !r) return r
    for (var p in s) {
      if (isOverWrite !== false || !(p in r)) {
        r[p] = s[p]
      }
    }
    return r
  },


  ccGetFormatDate: function (date, fmt) {
    console.log('getFormatDate!!!')
    var o = {
      'M+': date.getMonth() + 1, // 月份
      'd+': date.getDate(), // 日
      'h+': date.getHours(), // 小时
      'm+': date.getMinutes(), // 分
      's+': date.getSeconds(), // 秒
      'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
      'S': date.getMilliseconds()
      // 毫秒
    }
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '')
        .substr(4 - RegExp.$1.length))
    }
    for (var k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) :
          (('00' + o[k]).substr(('' + o[k]).length)))
      }
    }
    return fmt
  },
  // 将字符串转换成date
  ccConvertDateFromString: function (dateString) {
    if (dateString) {
      var arr1 = dateString.split(' ')
      var sdate = arr1[0].split('-')
      var time = arr1[1].split(':')
      var date = new Date(sdate[0], sdate[1] - 1, sdate[2], time[0], time[1], time[2])
      return date
    }
  },

  // 过滤表单的undefined属性
  ccFilterUndefined: function (obj) {
    for (let key in obj) {
      if (obj[key] === undefined || obj[key] === null) {
        delete obj[key]
      }
    }
    return obj
  },


  // 将html生成图片并下载
  // 依赖 html2canvas
  /**
   * @param {string} element : 需要生成图片的HTML节点，传入ID
   * @param {string} title : 生成图片的标题
   */
  ccDoDownloadHtmlAsImage: function (element, title) {
    html2canvas(document.body.querySelector(element), {
      allowTaint: true
    }).then(function (canvas) {

      //图片导出为 png 格式
      var type = 'png';
      var imgData = canvas.toDataURL(type);
      //console.log("imgData")
      //console.log(imgData)

      /**
       * 获取mimeType
       * @param  {String} type the old mime-type
       * @return the new mime-type
       */
      var _fixType = function (type) {
        type = type.toLowerCase().replace(/jpg/i, 'jpeg');
        var r = type.match(/png|jpeg|bmp|gif/)[0];
        return 'image/' + r;
      };

      // 加工image data，替换mime type
      imgData = imgData.replace(_fixType(type), 'image/octet-stream');

      /**
       * 在本地进行文件保存
       * @param  {String} data     要保存到本地的图片数据
       * @param  {String} filename 文件名
       */
      var saveFile = function (data, filename) {
        var save_link = document.createElementNS('http://www.w3.org/1999/xhtml', 'a');
        save_link.href = data;
        save_link.download = filename;

        var event = document.createEvent('MouseEvents');
        event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
        save_link.dispatchEvent(event);
      };

      // 下载后的文件名
      var filename = '二维码 .' + type;
      // download
      saveFile(imgData, filename);


    })
  },

  /**
   * [查找距离当前元素最近的父节点]
   * @param {node} el [ 当前dom节点 ]
   * @param {node} selector [ 想要的父节点选择器 ]
   */
  closest: function (el, selector) {
    const matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
  
    while (el) {
      if (matchesSelector.call(el, selector)) {
        return el;
      } else {
        el = el.parentElement;
      }
    }
    return null;
  }

}